import { withStyles } from "@mui/styles";
import { InputAdornment } from "@material-ui/core";
const StyledInputAdornment = withStyles({
  positionEnd: {
    paddingRight: "0",
  },
})(InputAdornment);
export { StyledInputAdornment };